import type { DebitNoteReportRow, PurchaseReportRow, PurchaseReturnReportRow } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { ReportFilters } from './useReportFilters';

export const purchasesReportKeys = {
  purchases: (filters: ReportFilters) => ['reports', 'purchases', filters] as const,
  purchaseReturns: (filters: ReportFilters) => ['reports', 'purchase-returns', filters] as const,
  debitNotes: (filters: ReportFilters) => ['reports', 'debit-notes', filters] as const,
};

/**
 * Branch + range only: these endpoints return the whole window and the page
 * applies search/filters client-side, so sending them would only bust the cache.
 */
function rangeQuery(filters: ReportFilters): string {
  return queryString({ branchId: filters.branchId, from: filters.from, to: filters.to });
}

export function fetchPurchases(filters: ReportFilters, signal?: AbortSignal): Promise<PurchaseReportRow[]> {
  return portalApi.get<PurchaseReportRow[]>(`/portal/reports/purchases${rangeQuery(filters)}`, { signal });
}

export function fetchPurchaseReturns(
  filters: ReportFilters,
  signal?: AbortSignal,
): Promise<PurchaseReturnReportRow[]> {
  return portalApi.get<PurchaseReturnReportRow[]>(`/portal/reports/purchase-returns${rangeQuery(filters)}`, {
    signal,
  });
}

export function fetchDebitNotes(filters: ReportFilters, signal?: AbortSignal): Promise<DebitNoteReportRow[]> {
  return portalApi.get<DebitNoteReportRow[]>(`/portal/reports/debit-notes${rangeQuery(filters)}`, { signal });
}
